import client from "./clients/portalClient";

const getAllNawCompanies = (cat) => client.get(`/accounts?data=${cat}`);
const getNawCompany = (id) => client.get(`/accounts/${id}`);
const getHistory = (id) => client.get(`/accounts/${id}/history`);
const postNewCompany = (data) => client.post(`/accounts`, data);
const editCompany = (id, data) => client.put(`/accounts/${id}`, data);
const deleteCompany = (id) => client.delete(`/accounts/${id}`);


const nawCompaniesApi = {
    getAllNawCompanies,
    getNawCompany,
    getHistory,
    postNewCompany,
    editCompany,
    deleteCompany
};

export default nawCompaniesApi;
